/// <amd-module name="TFS/Samples/EmptyTestComponent/EmptyTestComponent" />
import * as React from "react";

import { Components } from "VSS/Platform/Layout";

export class EmptyTestComponent extends React.Component {
    public render(): JSX.Element {
        return <span>"This is a simple component for use in empty-content page tests"</span>;
    }
}
Components.add("emptyTestComponent", EmptyTestComponent);
